module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/power-phone-0.9168947f.jpg";